import React, { useCallback, useEffect, useState } from 'react';
import "../NavBar/Header.css";
import { FaInstagram, FaFacebookSquare } from "react-icons/fa";
import { IoCart } from "react-icons/io5";
import { ImUser } from "react-icons/im";
import { Badge, Drawer } from 'antd';
import Logo from "../../Images/Logo/Logo.png";
import { Link } from 'react-router-dom';
import AddtoCart from '../../Pages/AddtoCart';
import SearchPage from '../SearchComponent/SearchPage';
import { IoMdSearch } from "react-icons/io";
import { setUserToken } from '../../features/authSlice';
import { LuMenu } from "react-icons/lu";
import { getProfile, getToken } from "../../services/localStorageServices";
import { useDispatch, useSelector } from "react-redux";
import { FaYoutube } from "react-icons/fa";
import { IoMailOutline } from "react-icons/io5";
import { FaXTwitter } from "react-icons/fa6";
import { useCartContext } from '../../context/addToCart';
import MainCategory from '../demoData/MainCategory';
import { useCurrency } from '../../services/locationService';
import countries from './countries.json';

const Header = ({ someProp }) => {
    const [isSticky, setIsSticky] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const { country, countryCode, code, rates, loading: currencyLoading, exchangeRateError, changeCountry } = useCurrency();
    const [regionSelectionError, setRegionSelectionError] = useState('');
    const { cartValue, openCartDrawer } = useCartContext();
    const { access_token } = getToken();
    const dispatch = useDispatch();

    const { token } = useSelector((state) => state.auth);
    useEffect(() => {
        dispatch(setUserToken({ token: access_token }));
    }, [access_token, dispatch]);

    const handleScroll = () => {
        if (window.scrollY > 20) {
            setIsSticky(true);
        } else {
            setIsSticky(false);
        }
    };

    const toggleSearch = () => {
        setIsSearchOpen((isOpen) => !isOpen);
    };

    const handleRegionChange = useCallback((selectedCountry) => {
        try {
            changeCountry(selectedCountry);
            setRegionSelectionError('');
            setOpen(false);
        } catch (error) {
            setRegionSelectionError(error.message || 'Could not select this country.');
        }
    }, [changeCountry]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const navbarClass = someProp ? 'black-navbar' : 'transparent-navbar';

    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };
    const handleMenuClick = () => {
        setOpen(false);
    };

    return (
        <>
            <section className={`Header-section-main-con ${isSticky ? 'sticky' : ''} ${navbarClass}`}>
                <div className='Header-Section-con'>
                    <div className='row'>
                        <div className='col-4 d-flex justify-content-start align-items-center'>
                            <div className='Header-social-media-main-con'>
                                <div className='Header-social-media-con'>
                                    <a href='https://www.instagram.com/1fiveglobal?igsh=MnRxenNtZWozMWhw' target='blank'><FaInstagram /></a>
                                    <a href='https://www.facebook.com/people/1FiveLuxury/61573584849714/?mibextid=wwXIfr&rdid=V1JCC7ErJAIG6JCi&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1Eq18XeuAx%2F%3Fmibextid%3DwwXIfr' target='blank'><FaFacebookSquare /></a>
                                    <a href='https://x.com/1fiveluxury?s=21&t=abNZb9BXQdbo-Hy7hi12Xg' target='blank'><FaXTwitter /></a>
                                    <a href='https://www.youtube.com/@1fiveluxury' target='blank'><FaYoutube /></a>
                                    <Link to="/contact"><IoMailOutline /></Link>
                                </div>
                                <div className='header-mobile-left-controls'>
                                    <button
                                        className='header-mobile-menu-btn header-responsive-menu-btn'
                                        type='button'
                                        onClick={showDrawer}
                                        aria-label='Open navigation menu'
                                        aria-expanded={open}
                                        aria-controls='header-navigation-drawer'
                                    >
                                        <LuMenu />
                                    </button>
                                    <button
                                        className='header-responsive-search-btn'
                                        type='button'
                                        onClick={toggleSearch}
                                        aria-label='Open search'
                                    >
                                        <IoMdSearch />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='col-4 d-flex justify-content-center align-items-center'>
                            <div className='Header-Logo-Main-Con'>
                                <Link to="/">
                                    <div className='Header-Logo-Con'>
                                        <img src={Logo} alt='Logo' />
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className='col-4 d-flex justify-content-end align-items-center'>
                            <div className='Header-Icons-Main-con'>
                                <div className='Header-Icons-con'>
                                    <div className='Header-Profile-Icons-Con header-account-icon'>
                                        <Link to={token ? "/order" : "/account/sign-in"}>
                                            <button title={token ? "order" : "/account/sign-in"}>
                                                <ImUser />
                                            </button>
                                        </Link>
                                    </div>
                                    <div className='Header-Profile-Icons-Con-search' onClick={toggleSearch}>
                                        <IoMdSearch />
                                    </div>
                                    <div className='Header-Profile-Icons-Con'
                                        onClick={openCartDrawer}
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#offcanvasRight"
                                        aria-controls="offcanvasRight">
                                        <Badge size="small" count={cartValue.length}>
                                            <IoCart />
                                        </Badge>
                                    </div>
                                    <button
                                        className='header-desktop-menu-btn header-responsive-menu-btn'
                                        type='button'
                                        onClick={showDrawer}
                                        aria-label='Open navigation menu'
                                        aria-expanded={open}
                                        aria-controls='header-navigation-drawer'
                                    >
                                        <LuMenu />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='main-menu-main-con'>
                                <div className='main-menu-con'>
                                    {
                                        MainCategory.map((item) => (
                                        
                                                <Link to={item.slug}>{item.name}</Link>
                                        
                                        ))
                                    }
                                    {/* <Link to="/men">Apparel</Link>
                                    <Link to="/Accessories">Fragrance</Link>
                                    <Link to="/women">Accessories</Link> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className='menu-side-bar-con'>
                <Drawer
                    id='header-navigation-drawer'
                    className='header-country-drawer'
                    title='SELECT YOUR COUNTRY / REGION'
                    onClose={onClose}
                    open={open}
                    placement='right'
                    width='min(420px, 92vw)'
                >
                    <div className='menu-side-bar-region'>
                        {(exchangeRateError || regionSelectionError) && (
                            <p className='menu-side-bar-region-error' role='alert'>
                                {regionSelectionError || exchangeRateError}
                            </p>
                        )}
                        {['Europe', 'Americas', 'Asia', 'Oceania', 'Africa'].map((region) => {
                            const regionCountries = countries.filter((item) => item.region === region);
                            if (!regionCountries.length) return null;

                            return (
                                <details className='menu-side-bar-region-group' key={region}>
                                    <summary>{region === 'Americas' ? 'America' : region}</summary>
                                    <div className='menu-side-bar-country-list'>
                                        {regionCountries.map((item) => {
                                            const currencyCode = Object.keys(item.currencies || {})[0];
                                            const currencySymbol = item.currencies[currencyCode]?.symbol || currencyCode;
                                            const languageCode = Object.keys(item.languages || {})[0];
                                            const hasRate = Boolean(rates[currencyCode]);

                                            return (
                                                <button
                                                    className='menu-side-bar-country'
                                                    type='button'
                                                    key={item.cca2}
                                                    onClick={() => handleRegionChange(item)}
                                                    disabled={currencyLoading || !hasRate}
                                                    title={currencyLoading ? 'Loading exchange rate' : (hasRate ? `Select ${item.name.common}` : `Live exchange rate for ${currencyCode} is unavailable`)}
                                                >
                                                    <span>{item.name.common} <em>({currencySymbol} {currencyCode})</em></span>
                                                    <span className='menu-side-bar-country-language'>
                                                        {languageCode ? languageCode.toUpperCase() : ''}
                                                        {!hasRate && !currencyLoading ? ' - Rate unavailable' : ''}
                                                    </span>
                                                </button>
                                            );
                                        })}
                                    </div>
                                </details>
                            );
                        })}
                    </div>

                    <div className='menu-side-bar-menu-con'>
                        <div className='menu-side-bar-menu' onClick={handleMenuClick}>
                            <Link to="/">Home</Link>
                        </div>
                        <div className='menu-side-bar-menu' onClick={handleMenuClick}>
                            <Link to="/accessories">Accessories</Link>
                        </div>
                        <div className='menu-side-bar-menu' onClick={handleMenuClick}>
                            <Link to="/fragrance">Fragrance</Link>
                        </div>
                        <div
                            className='menu-side-bar-menu' onClick={handleMenuClick}>
                            <Link to="/apparel">Apparel</Link>
                        </div>
                    </div>

                    <div className='menu-side-bar-menu-second-option'>
                        <div className='menu-side-bar-menu-second' onClick={handleMenuClick}>
                            <Link to={token ? "/order" : "/account/sign-in"}>
                                {token ? 'Profile' : 'Sign in'}
                            </Link>
                        </div>
                        <div className='menu-side-bar-menu-second' onClick={handleMenuClick}>
                            <Link to="/about">About</Link>
                        </div>
                        <div className='menu-side-bar-menu-second' onClick={handleMenuClick}>
                            <Link to="/contact">Contact</Link>
                        </div>
                        <div className='menu-side-bar-menu-second' onClick={handleMenuClick}>
                            <Link to="/return-policy">returns</Link>
                        </div>
                        <div className='menu-side-bar-menu-second' onClick={handleMenuClick}>
                            <Link to="/shipping-policy">shipping</Link>
                        </div>
                        <div className='menu-side-bar-menu-second' onClick={handleMenuClick}>
                            <Link to="/privacy-policies">Privacy policy</Link>
                        </div>
                        <div className='menu-side-bar-menu-second' onClick={handleMenuClick}>
                            <Link to="/terms-conditions">Terms & Conditions</Link>
                        </div>
                    </div>

                    <div className='menu-side-bar-menu-second-option-cosial-media'>
                        <a href='https://www.instagram.com/1fiveluxury?igsh=b2U4NmJlOHo4MXE2&utm_source=qr' target='blank'><FaInstagram /></a>
                        <a href='https://www.facebook.com/people/1FiveLuxury/61573584849714/?mibextid=wwXIfr&rdid=V1JCC7ErJAIG6JCi&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1Eq18XeuAx%2F%3Fmibextid%3DwwXIfr' target='blank'><FaFacebookSquare /></a>
                        <a href='https://x.com/1fiveluxury?s=21&t=abNZb9BXQdbo-Hy7hi12Xg' target='blank'><FaXTwitter /></a>
                        <a href='https://www.youtube.com/@1fiveluxury' target='blank'><FaYoutube /></a>
                        <Link to="/contact" onClick={handleMenuClick}><IoMailOutline /></Link>
                        {/* <a href="https://wa.me/+919892331133?text=" target='blank'><FaWhatsapp /></a>
                        <a href="tel:+919892331133" target='blank'><IoIosCall /></a> */}
                    </div>
                </Drawer>
            </div>

            <SearchPage toggleSearch={toggleSearch} isSearchOpen={isSearchOpen} />
            <AddtoCart />
        </>
    );
};

export default Header;
